import CardBody from 'components/Card/CardBody';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { Divider } from '@material-ui/core';
import CardWrapper from 'components/Card/CardWrapper';
import { useTranslation } from 'react-i18next';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import { makeStyles } from '@material-ui/styles';
import { type Dispatch, type SetStateAction } from 'react';
import { type Brand } from 'types/Brand';

type EcoContainersProps = {
  state: Brand;
  setState: Dispatch<SetStateAction<Brand>>;
};

const useStyles = makeStyles({
  divider: {
    marginBottom: '20px',
  },
});

const EcoContainers = ({ state, setState }: EcoContainersProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <CardWrapper title={t('brands.newBrandForm.ecoPackages')}>
      <CardBody>
        <GridContainer>
          <GridItem md={12}>
            <Divider className={classes.divider} />
            <LabeledCheckbox
              checked={state.ecoContainer}
              onChange={() => {
                setState(prevState => ({
                  ...prevState,
                  ecoContainer: !prevState.ecoContainer,
                }));
              }}
              label={t('brands.newBrandForm.eco')}
            />
          </GridItem>
        </GridContainer>
      </CardBody>
    </CardWrapper>
  );
};

export default EcoContainers;
